import { BlogLayout } from "@/components/layout/BlogLayout";

export default function Terms() {
  return (
    <BlogLayout title="Termos de Uso">
      <article className="prose prose-invert mx-auto max-w-3xl px-4 py-12">
        <h1>Termos de Uso</h1>
        <p className="text-muted-foreground">Última atualização: 14 de fevereiro de 2026</p>

        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao acessar ou utilizar a plataforma fotoCerta ("Serviço"), você concorda em cumprir
          estes Termos de Uso. Se você não concorda com algum dos termos, não utilize o Serviço.
        </p>

        <h2>2. Descrição do Serviço</h2>
        <p>
          O fotoCerta é uma plataforma de avaliação de fotos onde usuários recebem feedback
          honesto de pessoas reais sobre suas fotos. O Serviço permite que usuários avaliem
          fotos de outros usuários e submetam suas próprias fotos para avaliação.
        </p>

        <h2>3. Cadastro e Conta</h2>
        <p>
          Para utilizar o Serviço, você deve criar uma conta utilizando autenticação via Google
          ou link mágico por e-mail. Você é responsável por manter a segurança da sua conta e
          por todas as atividades realizadas nela.
        </p>

        <h2>4. Sistema de Créditos</h2>
        <p>
          O Serviço utiliza um sistema de créditos. Créditos de impulso são ganhos ao avaliar
          fotos de outros usuários. Créditos pagos podem ser adquiridos via Stripe ou PIX.
          Créditos não são reembolsáveis, exceto quando exigido por lei.
        </p>

        <h2>5. Conteúdo do Usuário</h2>
        <p>
          Ao enviar fotos para o Serviço, você declara que possui os direitos sobre o conteúdo
          enviado. Você concede ao fotoCerta uma licença limitada para exibir suas fotos aos
          outros usuários exclusivamente para fins de avaliação.
        </p>
        <p>É proibido enviar conteúdo que:</p>
        <ul>
          <li>Contenha nudez ou material sexualmente explícito</li>
          <li>Seja ofensivo, discriminatório ou viole direitos de terceiros</li>
          <li>Inclua fotos de menores de idade</li>
          <li>Viole qualquer lei aplicável</li>
        </ul>

        <h2>6. Conduta do Usuário</h2>
        <p>
          Ao utilizar o Serviço, você concorda em avaliar fotos de forma honesta e respeitosa.
          É proibido utilizar o Serviço para assédio, spam ou qualquer atividade maliciosa.
          Reservamo-nos o direito de suspender ou encerrar contas que violem estas regras.
        </p>

        <h2>7. Propriedade Intelectual</h2>
        <p>
          O Serviço, incluindo sua interface, marca, código e design, é propriedade do
          fotoCerta e está protegido por leis de propriedade intelectual. Você não pode
          copiar, modificar ou distribuir qualquer parte do Serviço sem autorização.
        </p>

        <h2>8. Isenção de Garantias</h2>
        <p>
          O Serviço é fornecido "como está". Não garantimos que o Serviço será ininterrupto,
          seguro ou livre de erros. As avaliações refletem opiniões individuais dos usuários
          e não representam a posição do fotoCerta.
        </p>

        <h2>9. Limitação de Responsabilidade</h2>
        <p>
          O fotoCerta não se responsabiliza por danos indiretos, incidentais ou consequenciais
          decorrentes do uso do Serviço. Nossa responsabilidade total será limitada ao valor
          pago por você nos últimos 12 meses.
        </p>

        <h2>10. Modificações dos Termos</h2>
        <p>
          Podemos atualizar estes Termos a qualquer momento. Notificaremos sobre alterações
          significativas por e-mail ou aviso na plataforma. O uso continuado do Serviço após
          as alterações constitui aceitação dos novos termos.
        </p>

        <h2>11. Rescisão</h2>
        <p>
          Você pode encerrar sua conta a qualquer momento. Reservamo-nos o direito de
          suspender ou encerrar sua conta caso haja violação destes Termos, sem aviso prévio.
        </p>

        <h2>12. Lei Aplicável</h2>
        <p>
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Qualquer
          disputa será resolvida no foro da comarca de São Paulo, SP.
        </p>

        <h2>13. Contato</h2>
        <p>
          Para dúvidas sobre estes Termos, entre em contato pelo e-mail{" "}
          <a href="mailto:contato@fotocerta.com">contato@fotocerta.com</a>.
        </p>
      </article>
    </BlogLayout>
  );
}
